import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import ErrorIcon from '@mui/icons-material/Error';
import DoneIcon from '@mui/icons-material/Done';



const SubmissionPopupError =(props)=>{
    const [open, setOpen] = useState(true);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);

    const handleClose = (event, reason) => {
        // Do not accept events not launch by the button (click outside the dialog)
        if (reason && reason == "backdropClick") return;
        setOpen(false);
        props.onClose();
    };

    useEffect(() => {     
        if (props.tableContents !== undefined) {
            if (props.tableContents.length > 0) {
                //1. Get first Row from tableContents
                let header = props.tableContents.find(e => true);
                header = ["id", ...header];
                //2. Get rest of the rows from tableContents
                let contents = props.tableContents.slice(1);
                //3. Updates columns
                setColumns(header.map((item,index) => {return {field:item, headerName:item, width:150};}));
                //4. Updates rows
                setRows(contents.map((item,index)=>{   
                    let row = {id:index};
                    let ndx = 0;
                    for (let title of header) {
                        if (title !== "id") {
                            row[title] = item[ndx];
                            ndx = ndx + 1;  
                        }
                    }
                    return row;
                }));
            }
        }   
    }, [])



    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth="xl"
            >
            <DialogTitle id="alert-dialog-title">
                {"Submission Issues"}
            </DialogTitle>
            <DialogContent style={{height:'600px'}}>
                <Card sx={{ margin: 2 }}>
                    <Typography style={{color: 'red'}}><ErrorIcon/> Submission Error:</Typography>
                    <Typography style={{color: 'red'}}>{props.errors}</Typography>
                </Card>
                
                { props.tableContents ?
                    <div style={{height:'500px', margin:4 }}>
                        <Typography style={{color: 'green'}}><DoneIcon/>{"Succesfully inserted data:"}</Typography>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={100}
                            rowsPerPageOptions={[100]}
                            sx={{ t: 1 }}
                        />
                    </div>
                  :
                    null
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Accept</Button>
            </DialogActions>
            </Dialog>
        </div>
    );
}

export default SubmissionPopupError;